export function GoalsPage() {
  return <div />
}
